import React, { useMemo } from "react";

// Sfondi animati leggeri (solo CSS: transform/opacity) per la home pubblica.
// Nessun canvas/video/3D. Si disattiva con prefers-reduced-motion.
const COUNT = { particles: 20, bubbles: 16, embers: 24 };

export const AnimatedFX = ({ variant, color = "#B2A475" }) => {
  const reduce = typeof window !== "undefined" && window.matchMedia
    ? window.matchMedia("(prefers-reduced-motion: reduce)").matches
    : false;

  const items = useMemo(() => {
    const n = COUNT[variant] || 0;
    return Array.from({ length: n }).map(() => ({
      left: Math.random() * 100,
      size: variant === "bubbles" ? 6 + Math.random() * 16 : 2 + Math.random() * 3.5,
      duration: (variant === "embers" ? 5 : 8) + Math.random() * 9,
      delay: -Math.random() * 14,
      drift: Math.random() * 50 - 25,
    }));
  }, [variant]);

  if (!variant || variant === "none" || reduce) return null;

  return (
    <div className={`animfx animfx-${variant}`} aria-hidden="true" data-testid="animated-fx">
      {items.map((it, i) => (
        <span
          key={i}
          className="fx"
          style={{
            left: `${it.left}%`,
            width: it.size,
            height: it.size,
            animationDuration: `${it.duration}s`,
            animationDelay: `${it.delay}s`,
            "--drift": `${it.drift}px`,
            "--c": color,
          }}
        />
      ))}
    </div>
  );
};

export default AnimatedFX;
